import { Chip } from "@material-ui/core";
import { Collection, Linked } from "@type-r/models";
import { Flex, asDateTime, span } from "lqx-react";
import React from "react";
import { UserEntitlementCatalogs } from "src/app/models/UserEntitlements";
import { Can } from "src/app/services/can";
import { AssetTypesDisplay } from "../api/assetType";
import { CompanyItem } from "../api/company";
import { AssetTypeName, Body, Container, Footer, FooterContent, FooterLabel, FooterRow, NameBlock, NameLabel, PolicyCardDate, Row, State, colorStyles } from "../components/item-card-styles";
import { DigiTooltip } from "../shared";
import { ValidationRulesActions } from "./validation-rules-actions";
import { ValidationRuleItem } from "../api/validationRuleItem";

export const ValidationRulesCardRenderer = (
    $activeCard: Linked<ValidationRuleItem>,
    onDelete?) =>
    ({ data, style, index }) => {
        const classes = colorStyles();
        const validationCard: ValidationRuleItem = data.items[index];
        const isActive = Boolean($activeCard.value) && validationCard.id === $activeCard.value.id;
        const importTemplateStatus = () => validationCard && validationCard.isActive ?
            <span className={classes.active}>Active</span> : <span className={classes.inactive}>Inactive</span>

        return (
            <Row style={style}>
                <Flex row grow>
                    <Container {...{ active: isActive ? 'true' : 'false' }} {...{ onClick: () => { $activeCard.set(validationCard) } }}>
                        <Body>
                            <Flex row>
                                <Flex column grow>
                                    <NameBlock>
                                        <State>{importTemplateStatus()}</State>
                                        <AssetTypeName> {validationCard.name}
                                            <DefaultChipContent className={classes.chipLabel} validationCard={validationCard} />
                                            <StandardChipContent className={classes.standardChipColor} validationCard={validationCard} />
                                        </AssetTypeName>
                                    </NameBlock>
                                    <Flex row>
                                        <PolicyCardDate>
                                            <NameLabel>
                                                {/* <CompaniesBlock companies={validationCard.companies}></CompaniesBlock> */}
                                            </NameLabel>
                                        </PolicyCardDate>
                                    </Flex>
                                </Flex>
                                {Can(UserEntitlementCatalogs.EditValidationRulePage) && !$activeCard.value &&
                                    <ValidationRulesActions validationCard={validationCard} onDelete={onDelete} />
                                }
                            </Flex>
                        </Body>
                        <Footer>
                            <Flex column>
                                <FooterRow>
                                    <FooterLabel>Asset Type:</FooterLabel><FooterContent>{AssetTypesDisplay[validationCard.assetTypeId]}</FooterContent>
                                </FooterRow>
                            </Flex>
                            <Flex column grow>
                                <FooterRow style={{ justifyContent: 'flex-end' }}>
                                    <FooterLabel>Created On:</FooterLabel><FooterContent>{asDateTime(validationCard.createdOn)}</FooterContent>
                                </FooterRow>
                            </Flex>
                        </Footer>
                    </Container>
                </Flex>
            </Row>
        )
    }

const CompaniesBlock = ({ companies }: { companies?: Collection<CompanyItem> }) => {
    if (!companies || companies.length < 1) return <></>
    if (companies.length === 1) return <> {companies.first().name} </>

    return (
        <>
            <DigiTooltip tooltipArrow popperArrow title={<CompaniesTooltipContent companies={companies}></CompaniesTooltipContent>} placement="bottom-start">
                <span>{companies.length} Companies </span>
            </DigiTooltip>
        </>
    )
}

const DefaultChipContent = ({ validationCard, className }: { validationCard: ValidationRuleItem, className?: any }) => {
    return validationCard.isDefault && validationCard.isActive
        ? <ChipContainer><Chip label="Default" className={className} variant="outlined" size="small" /></ChipContainer>
        : <></>
}

const StandardChipContent = ({ validationCard, className }: { validationCard: ValidationRuleItem, className?: any }) => {
    return validationCard.isStandard
        ? <ChipContainer><Chip label="Standard" className={className} variant="outlined" size="small" /></ChipContainer>
        : <></>
}

const CompaniesTooltipContent = ({ companies }: { companies?: Collection<CompanyItem> }) => {
    const limit = 10;
    if (!companies) return <></>
    if (companies.length <= limit) return <div> {companies.map(x => <> {x.name} <br /> </>)}</div>;

    const limittedArrayOfCompanies = companies.slice(0, limit);

    return (
        <>
            <div> {limittedArrayOfCompanies.map(x => <> {x.name} <br /> </>)}</div>
            <div> + {companies.length - limit} </div>
        </>
    );
}

const ChipContainer = span({
    marginLeft: '10px'
});
